import api from './api';

const sqsService = {
    listQueues:  ()            => api.get('/admin/sqs/queues'),
    peekMessages: (queueName)  => api.get(`/admin/sqs/queues/${encodeURIComponent(queueName)}/messages`),
    purgeQueue:  (queueName)   => api.delete(`/admin/sqs/queues/${encodeURIComponent(queueName)}/messages`),
};

export default sqsService;
